

















































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { CompletionStatus, MobileGetter, User } from 'frontend/types';
import LottieAnimation, { LottieOptions } from 'frontend/components/LottieAnimation.vue';
import Sparkles from 'frontend/animations/course-page/sparkles.json';
import GreenBorderFill from 'frontend/animations/course-page/green-border-fill.json';
import animationTimings, {
  animationsEventBus,
} from 'frontend/views/courses/CoursePage/utils/animationTimings';

type AnimationState = 'un-started' | 'in-progress' | 'finished';

@Component({
  components: { LottieAnimation },
  computed: {
    ...mapState('globals', ['user']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class LessonButton extends Vue {
  private user!: User;
  private isMobile!: MobileGetter;

  @Prop({ type: String, required: true })
  private link!: string;
  @Prop({ type: Boolean, required: true })
  private isLocked!: boolean;
  @Prop({ type: String, required: true })
  private completionStatus!: CompletionStatus;
  @Prop({ type: Boolean, default: false })
  private isRecommended!: boolean;
  @Prop({ type: Boolean, default: false })
  private isPractice!: boolean;
  @Prop({ type: Number, default: 0 })
  private practiceLessons!: number;
  @Prop({ type: Boolean, default: false })
  private isHighlighted!: boolean;
  @Prop({ type: Boolean, default: false })
  private isLast!: boolean;
  @Prop({ type: Boolean, default: false })
  private shouldAnimateCompleted!: boolean;
  @Prop({ type: Boolean, default: false })
  private shouldAnimatePractice!: boolean;
  @Prop({ type: Boolean, default: false })
  private enableJustCompletedAnimation!: boolean;
  @Prop({ type: Object, required: true })
  private trackingPayload!: { axId: string; axType: string; axExtra: any };

  private completedLessonAnimationState: AnimationState = 'un-started';
  private shouldAnimateRecommended: boolean = false;
  private animationsStarted: boolean = false;

  private get lessonButtonStateClass(): string {
    if (this.isLocked) {
      return 'locked';
    }
    if (this.isRecommended) {
      return 'recommended';
    }
    if (this.isHighlighted && this.completionStatus !== 'completed') {
      return 'highlighted';
    }
    if (this.shouldAnimateCompleted && this.completionStatus === 'completed') {
      switch (this.completedLessonAnimationState) {
        case 'un-started':
          return 'started';
        case 'in-progress':
          return 'started pressed';
        case 'finished':
          return 'completed';
      }
    }

    return this.completionStatus;
  }

  private get sparklesAnimation(): LottieOptions {
    return {
      animationData: Sparkles,
      loop: false,
      autoplay: true,
    };
  }

  private get greenBorderFillAnimation(): LottieOptions {
    return {
      animationData: GreenBorderFill,
      loop: false,
      autoplay: true,
    };
  }

  private get timingAnimationVariables(): { [key: string]: string } {
    return {
      '--tooltip-start': `${animationTimings.tooltipStart}ms`,
      '--tooltip-duration': `${animationTimings.tooltipDuration}ms`,
      '--jiggle-start': `${animationTimings.jiggleStart}ms`,
      '--jiggle-duration': `${animationTimings.jiggleDuration}ms`,
      '--pressing-duration': `${animationTimings.pressingDuration}ms`,
    };
  }

  private mounted(): void {
    animationsEventBus.$on('start-animations', () => {
      this.animationsStarted = true;
      this.startAnimationsTimeouts();
    });
  }

  private startAnimationsTimeouts(): void {
    if (this.enableJustCompletedAnimation) {
      if (this.shouldAnimateCompleted) {
        setTimeout(
          () => (this.completedLessonAnimationState = 'in-progress'),
          animationTimings.pressingStart,
        );
        setTimeout(() => {
          this.completedLessonAnimationState = 'finished';
        }, animationTimings.pressingStart + animationTimings.pressingDuration);
      }

      if (this.isRecommended) {
        setTimeout(() => (this.shouldAnimateRecommended = true), animationTimings.borderStart);
      }
    }
  }

  private preventIfLocked(event: Event): void {
    if (!this.user.is_authenticated || this.isLocked) {
      event.preventDefault();
      this.$emit('access-prevented');
    }
  }
}
